var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        ["checkbox-component"]: true,
        line: _vm.isLine,
        disable: _vm.isDisable,
      },
    },
    [
      _c("label", { attrs: { for: _vm.prefixId + _vm.id } }),
      _c("input", {
        attrs: {
          type: "checkbox",
          id: _vm.prefixId + _vm.id,
          name: _vm.id,
          hidden: "hidden",
          disabled: _vm.isDisable,
        },
        domProps: { checked: _vm.isChecked },
        on: { change: _vm.handleCheckboxChange },
      }),
      _c("div", { staticClass: "content-checkbox" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }